import React from "react";
import { useNavigate, Link } from "react-router-dom";
import "./BlogCard.css";
// removed unused BlogImg import

interface BlogCardProps {
  image: string;
  title: string;
  link: string;
  date?: string;
}

const BlogCard: React.FC<BlogCardProps> = ({ image, title, link, date }) => {
  const navigate = useNavigate();

  return (
    <div className="blog-card" onClick={() => navigate(link)}>
      <img src={image} alt={title} className="blog-card-img" />
      <h3 className="blog-card-title">
        {title.length > 50 ? title.slice(0, 50) + "..." : title}
      </h3>
      <p className="blog-card-date">{date}</p>
      <Link
        className="blog-card-readmore"
        to={link}
        onClick={(e) => e.stopPropagation()}
      >
        View Now <span className="blog-card-arrow">&#8594;</span>
      </Link>
    </div>
  );
};

export default BlogCard;
